/* =========================================================
   BlindTaste landing - /pages/blindbox
   - URL param parsing (profile, session_id, email, source)
   - Mode toggle (abbonamento vs box singola) - syncs hero + final
   - Plan selector (Lover / Expert) - syncs hero + final
   - Profile badge + discount banner conditional rendering
   - Sticky bottom CTA on mobile
   - Video carousel nav + autoplay-on-visible
   - Add to cart → Shopify /cart/add.js + cart attributes + checkout redirect
   ========================================================= */

(function () {
  "use strict";

  /* ---------- Profile label map (mirrors quiz PROFILES) ---------- */

  const PROFILE_LABELS = {
    "curioso-prudente": "Il Curioso Prudente",
    "esploratore":      "L'Esploratore",
    "narratore":        "Il Narratore",
    "degustatore":      "Il Degustatore"
  };

  const DISCOUNT_CODE = "BENVENUTO10";
  const DISCOUNT_PCT  = 10;

  const MODES = {
    abbonamento: { label: "/ mese",        suffix: "/ mese" },
    singolo:     { label: "",    suffix: "senza abbonamento" }
  };

  // Shopify product/cart wiring. Both variant IDs belong to the BlindBox product
  // (id 10416896311642). The selling_plan is the Appstle "Mensile" plan that
  // applies a -€20 fixed adjustment at checkout. We only attach selling_plan
  // when mode === "abbonamento".
  const BOX_VARIANTS = ["52272733552986", "52272915939674"];
  const SELLING_PLAN_ID = "692172095834";

  /* ---------- Helpers ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function getParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (_) { return null; }
  }

  function formatPrice(value) {
    const n = Number(value);
    if (!isFinite(n)) return "-";
    return "€" + n.toFixed(2).replace(".", ",");
  }

  function decodeEmail(b64) {
    if (!b64) return null;
    try { return atob(b64); } catch (_) { return null; }
  }

  /* ---------- State ---------- */

  const state = {
    sessionId: null,
    profile:   null,
    email:     null,
    source:    null,
    mode:      "abbonamento",
    plan:      "lover"
  };

  function readUrlState() {
    state.sessionId = getParam("session_id") || sessionStorage.getItem("bt:sessionId");
    state.profile   = getParam("profile");
    state.email     = decodeEmail(getParam("email"));
    state.source    = getParam("source");

    if (state.sessionId) {
      try { sessionStorage.setItem("bt:sessionId", state.sessionId); } catch (_) {}
    }
    if (state.profile) {
      try { sessionStorage.setItem("bt:profile", state.profile); } catch (_) {}
    } else {
      state.profile = sessionStorage.getItem("bt:profile");
    }
  }

  /* ---------- Profile badge + discount banner ---------- */
  // Both nodes are `hidden` by default. We only ever unhide if the URL
  // params justify it. (CSS [hidden] override is forced via the global
  // [hidden]{display:none!important} rule, so these checks now actually work.)

  function renderProfileBadge() {
    const node = $("#lp-profile-badge");
    const lbl  = $("#lp-profile-label");
    if (!node || !lbl) return;
    if (!state.profile || !PROFILE_LABELS[state.profile]) return;
    lbl.textContent = PROFILE_LABELS[state.profile];
    node.hidden = false;
  }

  function renderDiscount() {
    const node = $("#lp-discount");
    const active = !!state.email;
    document.body.classList.toggle("bt-has-discount", active);
    if (!node) return;
    node.hidden = !active;
  }

  function applyDiscount(price) {
    return state.email ? price * (1 - DISCOUNT_PCT / 100) : price;
  }

  /* ---------- Plan + mode selection ---------- */

  function refreshPlanPrices() {
    // Each plan card shows price for the current mode. When the BENVENUTO10
    // discount is active (?email=... in URL), we also show the original price
    // struck through, and the now-price is colored gold via CSS.
    const hasDiscount = !!state.email;
    $$(".lp-plan").forEach(function (plan) {
      const base = parseFloat(plan.getAttribute("data-price-" + state.mode));
      const final = hasDiscount ? applyDiscount(base) : base;

      const priceWas = plan.querySelector('[data-bind="priceWas"]');
      const priceNow = plan.querySelector('[data-bind="price"]');
      const modeNode = plan.querySelector('[data-bind="modeLabel"]');

      if (priceNow) priceNow.textContent = formatPrice(final);
      if (priceWas) {
        if (hasDiscount) {
          priceWas.textContent = formatPrice(base);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (modeNode) modeNode.textContent = MODES[state.mode].label;
    });
  }

  function refreshCtaPrice() {
    const selected = $('.lp-plan.is-selected[data-plan="' + state.plan + '"]');
    if (!selected) return;
    const base = parseFloat(selected.getAttribute("data-price-" + state.mode));
    const hasDiscount = !!state.email;
    const final = hasDiscount ? applyDiscount(base) : base;
    const finalFmt = formatPrice(final);
    const baseFmt  = formatPrice(base);
    const modeSuffix = MODES[state.mode].suffix;

    ["#lp-cta-price", "#lp-cta-price-final", "#lp-cta-price-sticky"].forEach(function (sel) {
      const n = $(sel); if (n) n.textContent = finalFmt;
    });
    ["#lp-cta-price-was", "#lp-cta-price-was-final", "#lp-cta-price-was-sticky"].forEach(function (sel) {
      const n = $(sel); if (!n) return;
      if (hasDiscount) {
        n.textContent = baseFmt;
        n.hidden = false;
      } else {
        n.hidden = true;
      }
    });
    ["#lp-cta-mode", "#lp-cta-mode-final"].forEach(function (sel) {
      const n = $(sel); if (n) n.textContent = modeSuffix;
    });
  }

  function selectMode(mode) {
    if (!MODES[mode]) return;
    state.mode = mode;
    $$(".lp-mode").forEach(function (btn) {
      const isMatch = btn.dataset.mode === mode;
      btn.classList.toggle("is-selected", isMatch);
      btn.setAttribute("aria-selected", isMatch ? "true" : "false");
    });
    // Toggle body class so CSS can show the "Disdici quando vuoi" pill only
    // when the user has Abbonamento selected.
    document.body.classList.toggle("bt-mode-abbonamento", mode === "abbonamento");
    document.body.classList.toggle("bt-mode-singolo", mode === "singolo");
    refreshPlanPrices();
    refreshCtaPrice();
  }

  function selectPlan(plan) {
    state.plan = plan;
    $$(".lp-plan").forEach(function (btn) {
      const isMatch = btn.dataset.plan === plan;
      btn.classList.toggle("is-selected", isMatch);
      btn.setAttribute("aria-checked", isMatch ? "true" : "false");
    });
    refreshCtaPrice();
  }

  function wireSelectors() {
    $$(".lp-mode").forEach(function (btn) {
      btn.addEventListener("click", function () { selectMode(btn.dataset.mode); });
    });
    $$(".lp-plan").forEach(function (btn) {
      btn.addEventListener("click", function () { selectPlan(btn.dataset.plan); });
    });
    // initial state
    selectMode(state.mode);
    selectPlan(state.plan);
  }

  /* ---------- Add to cart ---------- */
  // Flow:
  //   1. Fetch current cart
  //   2. Remove any line items that are BlindBox variants (Lover/Expert, sub
  //      or one-time) so we never end up with duplicates or mixed plans
  //   3. Set cart attributes carrying the quiz session for order attribution
  //   4. Add the selected variant. If mode==="abbonamento", attach the
  //      Appstle selling_plan; Shopify will apply the -€20 discount at checkout
  //   5. Redirect to /checkout (with ?discount=BENVENUTO10 if user came from quiz)

  async function addToCart() {
    const selected = $('.lp-plan.is-selected[data-plan="' + state.plan + '"]');
    if (!selected) return;

    const variantId = selected.getAttribute("data-variant");
    const sellingPlanId = state.mode === "abbonamento"
      ? (selected.getAttribute("data-selling-plan") || SELLING_PLAN_ID)
      : null;

    if (!variantId) {
      console.warn("[BT landing] missing data-variant on selected plan");
      alert("Configurazione mancante. Riprova tra un momento.");
      return;
    }

    const properties = {
      "Profilo BlindTaste": state.profile ? (PROFILE_LABELS[state.profile] || state.profile) : "",
      "_quiz_session_id":   state.sessionId || ""
    };
    Object.keys(properties).forEach(function (k) {
      if (!properties[k]) delete properties[k];
    });

    try {
      // 1) read current cart (best-effort — failure shouldn't block checkout)
      let cart = null;
      try {
        const cartRes = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
        if (cartRes.ok) cart = await cartRes.json();
      } catch (_) { /* swallow — proceed without cleanup */ }

      // 2) remove existing BlindBox lines (any of the 2 variants, any sub state)
      if (cart && Array.isArray(cart.items)) {
        const updates = {};
        cart.items.forEach(function (item) {
          if (BOX_VARIANTS.indexOf(String(item.variant_id)) !== -1) {
            updates[item.key] = 0;
          }
        });
        if (Object.keys(updates).length > 0) {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          });
        }
      }

      // 3) set cart attributes (quiz attribution for the Supabase webhook)
      if (state.sessionId) {
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              quiz_session_id: state.sessionId,
              quiz_profile:    state.profile || ""
            }
          })
        });
      }

      // 4) add the chosen variant (+ optional selling_plan)
      const addBody = {
        id: variantId,
        quantity: 1
      };
      if (Object.keys(properties).length > 0) addBody.properties = properties;
      if (sellingPlanId) addBody.selling_plan = sellingPlanId;

      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(addBody)
      });

      if (!addRes.ok) {
        const txt = await addRes.text();
        console.error("[BT landing] add to cart failed:", addRes.status, txt);
        alert("Si è verificato un problema con l'aggiunta al carrello. Riprova o contattaci.");
        return;
      }

      // 5) checkout
      const checkoutUrl = state.email
        ? "/checkout?discount=" + encodeURIComponent(DISCOUNT_CODE)
        : "/checkout";
      window.location.href = checkoutUrl;

    } catch (err) {
      console.error("[BT landing] add to cart error:", err);
      alert("Errore di rete. Riprova tra un momento.");
    }
  }

  function wireCtas() {
    ["#lp-cta-hero", "#lp-cta-final", "#lp-cta-sticky"].forEach(function (sel) {
      const node = $(sel);
      if (node) node.addEventListener("click", addToCart);
    });
  }

  /* ---------- Hero carousel ---------- */
  // Auto-fade through the hero images. Pause on hover. Dots let the user jump.
  function wireHeroCarousel() {
    const carousel = $("#lp-hero-carousel");
    if (!carousel) return;
    const slides = $$(".lp-hero__photo", carousel);
    const dots   = $$(".lp-hero__dot", $("#lp-hero-dots"));
    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;
    const INTERVAL = 5000;

    function go(idx) {
      current = (idx + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("is-active", i === current); });
      dots.forEach(function (d, i)  { d.classList.toggle("is-active", i === current); });
    }
    function next() { go(current + 1); }
    function start() { stop(); timer = setInterval(next, INTERVAL); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d) {
      d.addEventListener("click", function () {
        go(Number(d.dataset.slide));
        start(); // reset interval
      });
    });

    // Pause when the user hovers the carousel (desktop nicety).
    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", start);

    // Cross-device swipe via Pointer Events (mouse + touch + pen).
    // We only react if the gesture is dominantly horizontal so vertical
    // page-scroll on touch keeps working.
    const SWIPE_THRESHOLD = 40;
    let startX = null, startY = null, isHorizontal = false, activePointer = null;

    carousel.addEventListener("pointerdown", function (e) {
      // Let clicks on dots through (they have their own handler)
      if (e.target.closest(".lp-hero__dot")) return;
      // Only primary button on mouse; touch/pen always have button === 0
      if (e.pointerType === "mouse" && e.button !== 0) return;

      startX = e.clientX;
      startY = e.clientY;
      isHorizontal = false;
      activePointer = e.pointerId;
      try { carousel.setPointerCapture(e.pointerId); } catch (_) {}
      stop();
    });

    carousel.addEventListener("pointermove", function (e) {
      if (startX === null || e.pointerId !== activePointer) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        isHorizontal = true;
      }
    });

    function endSwipe(e) {
      if (startX === null || (e && e.pointerId !== activePointer)) return;
      const dx = e ? e.clientX - startX : 0;
      if (isHorizontal && Math.abs(dx) > SWIPE_THRESHOLD) {
        if (dx < 0) go(current + 1);
        else        go(current - 1);
      }
      startX = startY = null;
      isHorizontal = false;
      activePointer = null;
      start();
    }

    carousel.addEventListener("pointerup",     endSwipe);
    carousel.addEventListener("pointercancel", endSwipe);
    carousel.addEventListener("pointerleave",  endSwipe);

    // Pause when the tab is not visible (saves CPU).
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else start();
    });

    start();
  }

  /* ---------- Logo: scroll to top ---------- */
  // The logo links to "#" - we hijack the click to scroll smoothly to the top
  // of the page (not the homepage) and to avoid leaving "#" in the URL.
  function wireLogoScrollTop() {
    const logo = $(".lp-logo");
    if (!logo) return;
    logo.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---------- Sticky bottom CTA ---------- */

  function wireStickyCta() {
    const sticky = $("#lp-sticky");
    const hero = $(".lp-hero");
    if (!sticky || !hero) return;

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.hidden = e.isIntersecting;
      });
    }, { threshold: 0.1 });

    io.observe(hero);
  }

  /* ---------- Reel audio toggle ---------- */
  // Click anywhere on the video media (or the small speaker pill) toggles audio
  // for THAT reel. Any other reel that was playing audio gets muted. The IG icon
  // in the footer is the only navigation to Instagram.
  function wireReelSound() {
    $$(".lp-reel").forEach(function (reel) {
      const media = reel.querySelector(".lp-reel__media");
      const btn   = reel.querySelector(".lp-reel__sound");
      const video = reel.querySelector("video");
      if (!media || !video) return;

      function toggleAudio() {
        const willEnable = video.muted;

        // mute all other reels + reset their sound buttons
        $$(".lp-reel video").forEach(function (v) {
          if (v !== video) v.muted = true;
        });
        $$(".lp-reel__sound").forEach(function (b) {
          if (b !== btn) {
            b.classList.remove("is-on");
            b.setAttribute("aria-pressed", "false");
            b.setAttribute("aria-label", "Attiva audio");
          }
        });

        video.muted = !willEnable;
        if (btn) {
          btn.classList.toggle("is-on", willEnable);
          btn.setAttribute("aria-pressed", String(willEnable));
          btn.setAttribute("aria-label", willEnable ? "Silenzia audio" : "Attiva audio");
        }

        if (willEnable) {
          const p = video.play();
          if (p && typeof p.catch === "function") p.catch(function () {});
        }
      }

      // The whole media area toggles audio when clicked
      media.addEventListener("click", function () { toggleAudio(); });

      // Keep the small speaker pill clickable too (already inside media so
      // it bubbles up - stopPropagation to avoid double-toggling)
      if (btn) {
        btn.addEventListener("click", function (e) {
          e.stopPropagation();
          toggleAudio();
        });
      }
    });
  }

  /* ---------- Bottle reveal (mystery section) ---------- */
  // Desktop hover stays CSS-driven. Click/tap = explicit reveal that persists
  // until another bottle is tapped - only ONE bottle revealed at a time.
  function wireBottleReveal() {
    const bottles = $$("[data-reveal]");
    bottles.forEach(function (el) {
      el.addEventListener("click", function () {
        const wasRevealed = el.classList.contains("is-revealed");
        bottles.forEach(function (other) { other.classList.remove("is-revealed"); });
        if (!wasRevealed) el.classList.add("is-revealed");
      });
    });
  }

  /* ---------- Videos carousel ---------- */

  function wireVideosCarousel() {
    const rail = $("#lp-videos-rail");
    if (!rail) return;
    const prev = $("#lp-videos-prev");
    const next = $("#lp-videos-next");

    function scrollByOne(dir) {
      const card = rail.querySelector(".lp-reel");
      if (!card) return;
      const styles = getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || 16) || 16;
      const delta = (card.offsetWidth + gap) * dir;
      rail.scrollBy({ left: delta, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { scrollByOne(-1); });
    if (next) next.addEventListener("click", function () { scrollByOne( 1); });

    const cards = $$(".lp-reel");
    if (!("IntersectionObserver" in window)) return;

    // Autoplay only the most visible reel; pause the others.
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        const video = e.target.querySelector("video");
        if (!video) return;
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          const p = video.play();
          if (p && typeof p.catch === "function") p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.6, 1], root: rail });
    cards.forEach(function (c) { io.observe(c); });
  }

  /* ---------- Init ---------- */

  document.addEventListener("DOMContentLoaded", function () {
    readUrlState();
    renderProfileBadge();
    renderDiscount();
    wireSelectors();
    wireCtas();
    wireLogoScrollTop();
    wireStickyCta();
    wireBottleReveal();
    wireVideosCarousel();
    wireReelSound();
    wireHeroCarousel();

    window.__btLanding = { state, selectMode, selectPlan, addToCart, DISCOUNT_CODE, DISCOUNT_PCT };
  });
})();
